import React, { useState, useEffect } from 'react'
import { Panel, SelectPicker, Input, Row, Col, Table, Icon, ButtonGroup, IconButton } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { sessionGetItemStr, sessionRemoveItem, sessionSetItemStr } from '../../utils/sessionHelpers'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { DD_MM_YYYY_SLASH, REQUEST_DATE_FORMAT } from '../../constants/date'
import TagCell from '../../components/cell/TagCell'
import { getColorItemBookingStatus } from './BookingStatusUtils'

export default function AssetBookingManagementTable({
  schema,
  searchForm,
  loading,
  onReload = () => {},
  onSelect = () => {},
  onSearch = () => {},
  onPreview = () => {},
  lengthMenu,
  disableAdd,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [tableData, setTableData] = useState([])
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [reserveDocNo, setReserveDocNo] = useState()
  const [project, setProject] = useState()
  const [reserveStartDate, setReserveStartDate] = useState()
  const [reserveEndDate, setReserveEndDate] = useState()
  const [reserveExpiredStartDate, setReserveExpiredStartDate] = useState()
  const [reserveExpiredEndDate, setReserveExpiredEndDate] = useState()
  const [reserveStatus, setReserveStatus] = useState()

  const fs = localStorage.getItem('fontSize')
  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  const handleSearch = async () => {
    // console.log('handleSearch')
    let request = {
      reserveDocNo: reserveDocNo || '',
      project: project || null,
      reserveStartDate: reserveStartDate
        ? moment(reserveStartDate).format(REQUEST_DATE_FORMAT)
        : null,
      reserveEndDate: reserveEndDate ? moment(reserveEndDate).format(REQUEST_DATE_FORMAT) : null,
      reserveExpiredStartDate: reserveExpiredStartDate
        ? moment(reserveExpiredStartDate).format(REQUEST_DATE_FORMAT)
        : null,
      reserveExpiredEndDate: reserveExpiredEndDate
        ? moment(reserveExpiredEndDate).format(REQUEST_DATE_FORMAT)
        : null,
      reserveStatus: reserveStatus || null,
    }
    onSearch(request, 1, displayLength)
  }

  const handleCancel = async () => {
    // console.log('handleCancel')
    setReserveDocNo('')
    setProject('')
    setReserveStartDate('')
    setReserveEndDate('')
    setReserveExpiredStartDate('')
    setReserveExpiredEndDate('')
    setReserveStatus('')
    setDisplayLength(5)
    onSearch({}, 1, 5)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        displayLength,
        dataKey,
        reserveDocNo || '',
        project || null,
        reserveStartDate ? moment(reserveStartDate).format(REQUEST_DATE_FORMAT) : null,
        reserveEndDate ? moment(reserveEndDate).format(REQUEST_DATE_FORMAT) : null,
        reserveExpiredStartDate
          ? moment(reserveExpiredStartDate).format(REQUEST_DATE_FORMAT)
          : null,
        reserveExpiredEndDate ? moment(reserveExpiredEndDate).format(REQUEST_DATE_FORMAT) : null,
        reserveStatus || null
      )
    }
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', typeof onReload === 'function', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        dataKey,
        1,
        reserveDocNo || '',
        project || null,
        reserveStartDate ? moment(reserveStartDate).format(REQUEST_DATE_FORMAT) : null,
        reserveEndDate ? moment(reserveEndDate).format(REQUEST_DATE_FORMAT) : null,
        reserveExpiredStartDate
          ? moment(reserveExpiredStartDate).format(REQUEST_DATE_FORMAT)
          : null,
        reserveExpiredEndDate ? moment(reserveExpiredEndDate).format(REQUEST_DATE_FORMAT) : null,
        reserveStatus || null
      )
    }
  }

  return (
    <>
      <Panel header={`${searchForm?.header || 'ค้นหา'}`} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: -10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.reserveDocNo.label}
            <Input
              placeholder={searchForm.reserveDocNo.hint || searchForm.reserveDocNo.label}
              value={reserveDocNo}
              onChange={(value) => {
                setReserveDocNo(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.project.label}
            <Input
              placeholder={searchForm.project.hint || searchForm.project.label}
              value={project}
              onChange={(value) => {
                setProject(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.reserveStartDate.label}
            <DatePickerCustom
              {...props}
              placement="auto"
              value={reserveStartDate}
              disabledDate={(date) =>
                reserveEndDate && moment(reserveEndDate).isBefore(date, new Date())
              }
              onChange={(value) => {
                setReserveStartDate(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.reserveEndDate.label}
            <DatePickerCustom
              {...props}
              placement="auto"
              value={reserveEndDate}
              disabledDate={(date) =>
                reserveStartDate && moment(reserveStartDate).isAfter(date, new Date())
              }
              onChange={(value) => {
                setReserveEndDate(value)
              }}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.reserveExpiredStartDate.label}
            <DatePickerCustom
              {...props}
              placement="auto"
              value={reserveExpiredStartDate}
              disabledDate={(date) =>
                reserveExpiredEndDate && moment(reserveExpiredEndDate).isBefore(date, new Date())
              }
              onChange={(value) => {
                setReserveExpiredStartDate(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.reserveExpiredEndDate.label}
            <DatePickerCustom
              {...props}
              placement="auto"
              value={reserveExpiredEndDate}
              disabledDate={(date) =>
                reserveExpiredStartDate && moment(reserveExpiredStartDate).isAfter(date, new Date())
              }
              onChange={(value) => {
                setReserveExpiredEndDate(value)
              }}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.reserveStatus.label}
            <SelectPicker
              searchable={false}
              data={searchForm.reserveStatus.options}
              value={reserveStatus}
              block
              placeholder={`เลือก${searchForm.reserveStatus.label || ''}`}
              onChange={(value) => {
                setReserveStatus(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <div style={{ marginTop: 23 }}>
              <SearchButton
                disabled={loading}
                onClick={handleSearch}
                style={{ marginTop: 0, marginLeft: 0 }}
              >
                ค้นหา
              </SearchButton>
              <CancelButton onClick={handleCancel} style={{ marginTop: 0, marginLeft: 10 }}>
                ยกเลิก
              </CancelButton>
            </div>
          </Col>

          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>
      </Panel>

      {!disableAdd && (
        <Row style={{ marginTop: 20 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton
              icon="plus-square"
              disabled={false}
              onClick={() => {
                // sessionSetItemStr('isViewOnly', 'isViewOnly')
                sessionRemoveItem('isViewOnly')
                onSelect(null)
              }}
              style={{
                marginRight: 10,
              }}
            >
              สร้างคำขอจอง
            </SaveButton>
          </Col>
        </Row>
      )}

      <Table
        wordWrap
        minHeight={400}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
        data={tableData || []}
        style={{ marginTop: '10px' }}
      >
        <Column width={100} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell>เลขที่คำขอจอง</HeaderCell>
          <Cell dataKey="reserveDocNo" />
        </Column>

        <Column width={140} align="center">
          <HeaderCell>วันที่ขอจอง</HeaderCell>
          <Cell dataKey="reserveDate" />
        </Column>

        <Column width={160} align="center">
          <HeaderCell>วันที่หมดอายุการจอง</HeaderCell>
          <Cell dataKey="reserveExpiredDate" />
        </Column>

        <Column width={160} align="center">
          <HeaderCell>จำนวนครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetCount" />
        </Column>

        <Column width={160} align="center">
          <HeaderCell>สถานะการขอจอง</HeaderCell>
          <Cell>
            {(rowData) => {
              const item = getColorItemBookingStatus(rowData.reserveStatus)

              return (
                <TagCell
                  dataKey="reserveStatusName"
                  rowData={rowData}
                  bgColor={item.bgColor}
                  color={item.fontColor}
                />
              )
            }}
          </Cell>
        </Column>

        <Column width={200}>
          <HeaderCell a>ผู้ขอจอง</HeaderCell>
          <Cell dataKey="reserver" />
        </Column>

        <Column minWidth={160} flexGrow={1}>
          <HeaderCell>จองให้โครงการ</HeaderCell>
          <Cell dataKey="reserveToProject" />
        </Column>

        <Column width={130} align="center" fixed="right">
          <HeaderCell>จัดการรายการ</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ButtonGroup>
                    <>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-df"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => {
                          onSelect(rowData)
                          if (disableAdd) {
                            sessionRemoveItem('isViewOnly')
                          } else {
                            sessionSetItemStr('isViewOnly', 'isViewOnly')
                          }
                        }}
                      ></IconButton>

                      {!disableAdd && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          size="sm"
                          disabled={rowData.reserveStatus == 5}
                          icon={<Icon icon="edit" className="bt-gost-icon-none-radius-edit" />}
                          onClick={(e) => {
                            onSelect(rowData)
                            sessionRemoveItem('isViewOnly')
                          }}
                        ></IconButton>
                      )}

                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-info"
                        disabled={rowData.reserveStatus == 5}
                        size="sm"
                        icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                        onClick={() => onPreview(rowData)}
                      ></IconButton>
                    </>
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <TablePagination
        lengthMenu={lengthMenu || defaultLengthMenu}
        activePage={page || defaultPage}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total || 0} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
